<template>
    <a :href="route">
        <i class="fas fa-times-circle"></i>
    </a>
</template>

<script>
    export default {
        props: {
            route: {
                required: true,
                type: String
            }
        }
    }
</script>
